<template>
  <Modal
    v-model="state"
    :title="plustitle"
    width="600"
    class-name="c-docs vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="m-form">
      <Form :label-width="90">
        <FormItem label="媒体">
          <RadioGroup v-model="setInfo.media" type="button">
            <Radio label="baidu" :disabled="edit">百度信息流</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="账号">
          <ElSelect v-model="setInfo.adAccountId" :popper-append-to-body="false" clearable filterable style="width: 300px" :disabled="edit">
            <el-option v-for="option in accountData" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </FormItem>
        <FormItem label="游戏">
          <ElSelect v-model="setInfo.gameId" :popper-append-to-body="false" clearable filterable style="width: 300px" :disabled="edit">
            <el-option v-for="option in ALL_GAMES" :value="option.id" :label="option.name" :key="option.id"></el-option>
          </ElSelect>
        </FormItem>
        <FormItem label="落地页URL">
          <Input
            v-model="setInfo.logidUrl"
            style="width: 400px"
            placeholder="请填写百度创建的小游戏落地页地址，仅支持http和https开头的合法url"
          />
        </FormItem>

        <FormItem label="数据上报token">
          <Input v-model="setInfo.token" style="width: 400px" placeholder="请前往百度后台-转化追踪-转化详情页面取token" />
        </FormItem>
      </Form>
    </div>

    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { initPageData, ALL_GAMES } from '@/data/global-opts'

// 当前页面需要的下拉数据项
// GAMES: 全部游戏

const PAGE_REQUIRED_OPTS = initPageData([ALL_GAMES])
export default {
  name: 'baiduSet',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean,
      default() {
        return false
      }
    },
    accountData: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    bindGetData(e) {
      if (e) return
      this.setInfo = {
        logidUrl: '',
        adAccountId: '',
        gameId: '',
        media: 'baidu',
        token: ''
      }
    },
    updateInfo() {
      const info = JSON.parse(JSON.stringify(this.info))
      this.setInfo = info
    },
    // 提交验证
    save() {
      // 落地页校验
      if (!this.setInfo.logidUrl) {
        this.$Message.error('落地页URL不能为空！')
        return
      } else if (!this.setInfo.logidUrl.startsWith('http://') && !this.setInfo.logidUrl.startsWith('https://')) {
        this.$Message.error('落地页URL只支持http和https开头的url')
        return
      }

      if (!this.setInfo.gameId) {
        this.$Message.error('游戏不能为空！')
        return
      }
      if (!this.setInfo.adAccountId) {
        this.$Message.error('账号不能为空！')
        return
      }
      if (!this.setInfo.token) {
        this.$Message.error('token不能为空！')
        return
      }
      this.$emit('on-save', this.setInfo)
    }
  },
  data() {
    return {
      groupState: null,
      setInfo: {
        token: '',
        logidUrl: '',
        adAccountId: '',
        gameId: '',
        media: 'baidu'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  }
}
</script>
<style lang="scss" scoped>
.c-docs {
  position: relative;

  .m-form {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    max-height: 480px;
  }
}
</style>
